import qs from 'qs'
import api from '../api'
import sessionStorageUtil from './sessionStorageUtil'
import userAgentHelper from './userAgentHelper'
import { getNowFormatDate } from './dateFormat'
import {getAuth} from '../mixins/authorize'

let browser = userAgentHelper.browser;
let linkQs = qs.parse(location.search.substring(1));

//  扫码入口设定sessionStorage
export function setScanPay() {
  if (linkQs && linkQs.landlordId && linkQs.originId) {
    let channel = '';
    if (parseInt(linkQs.originId) === 0 || (sessionStorageUtil.get('scanPay') || {}).originId == '0') {	//线下物料生成二维码
      channel = (browser === 'weixin' ? '74' : (browser === 'ali' ? '75' : '76'))
    } else if (parseInt(linkQs.originId) === 1 || (sessionStorageUtil.get('scanPay') || {}).originId == '1') {	//线上生成二维码
      channel = (browser === 'weixin' ? '71' : (browser === 'ali' ? '72' : '73'))
    } else {
      channel = (browser === 'weixin' ? '10' : (browser === 'ali' ? '11' : '9'))
    }
    const originId = linkQs.originId;
    if (originId) {
      sessionStorageUtil.set({
        landlordId: linkQs.landlordId || sessionStorageUtil.get('scanPay').landlordId,
        _channel: channel,
        originId: originId
      }, 'scanPay');
    }
  }
}

export function sendScanPoint(buriedParams) {
  if ((sessionStorageUtil.get('scanPay') || {}).originId) {
    api.analytics.sendScanPoint({
      "extend": JSON.stringify(Object.assign({
        "renterId": getAuth() && getAuth()['userId'],
        "originId": (sessionStorageUtil.get('scanPay') || {}).originId,
        "scanChannel": browser === 'weixin' ? 'renter_weixin' : (browser === 'ali' ? 'renter_alipay' : 'renter_other')
      }, buriedParams.extend)),
      "pn": buriedParams.pn,
      "uid": getAuth() && getAuth()['userId'],
      "site": "renterembed",
      "channel": "h5",
      "accesstime": getNowFormatDate(),
      "referer": document.referrer,
      "uuid": (getAuth() && getAuth()['openId']) || 0,
      "cstamp": +new Date(),
      "url": location.href
    }).then();
  }
}



// WEBPACK FOOTER //
// ./src/library/scanPayPoint.js